// extracted by mini-css-extract-plugin
export default {"gridContainer":"News_gridContainer__75JW8","inner":"News_inner__165GS","title":"News_title__7Dj8f","gridItemImg":"News_gridItemImg__lOeA0"};